import { NgModule } from '@angular/core';
import { SubscriptionChangeDialogComponent } from '@client/shared/components/subscription/subscription-change-dialog/subscription-change-dialog.component';
import { CommonModule } from '@angular/common';
import { SubscriptionPaymentFailureDialogComponent } from './subscription-payment-failure-dialog/subscription-payment-failure-dialog.component';
import { MaterialModule } from '@shared/material/material.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from '@shared/pipe/pipe.module';
import { PreloaderModule } from '@shared/component';
import { InputNumberModule } from 'primeng/inputnumber';
import { PromoCodeFormComponent } from '@client/shared/components/subscription/promo-code-form/promo-code-form.component';
import { ConfirmPopupComponent } from '@shared/component/form-controls/confirm-popup/confirm-popup.component';
import {
  SubscriptionChangeDisclaimerComponent
} from '@client/shared/components/subscription/subscription-change-disclaimer/subscription-change-disclaimer.component';

/**
 * @TODO Alex why not imported in parent shared module?
 */
@NgModule({
  declarations: [
    SubscriptionChangeDialogComponent,
    SubscriptionPaymentFailureDialogComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    DirectivesModule,
    FormsModule,
    PipeModule,
    PromoCodeFormComponent,
    PreloaderModule,
    ConfirmPopupComponent,
    ReactiveFormsModule,
    SubscriptionChangeDisclaimerComponent,
    InputNumberModule
  ],
  exports: [
    SubscriptionChangeDialogComponent,
    PromoCodeFormComponent,
  ],
})
export class SubscriptionModule { }
